import { OptJobStatus, TERMINAL_OPT_JOB_STATUSES } from 'api/optJobs/optJobs.api'
import { OptJobOutcome } from './optJobOutcome.types'

/** Publishing an Unsolvable plan failed; other Unsolvable jobs retain their solver outcome. */
export function toOptJobOutcome(status: OptJobStatus, isPublishedPlan = false): OptJobOutcome {
  if (status === 'Unsolvable') return isPublishedPlan ? 'failed' : 'unsolvable'
  if (status === 'Failed') return 'failed'
  if (TERMINAL_OPT_JOB_STATUSES.has(status)) return 'finished'
  return 'created'
}
